import { useCallback } from 'react'
import { useMutation } from '@tanstack/react-query'
import { genericApi } from '~/api'

export const useRegisterMutation = (token) => {
  const mutation = useMutation(async (payload) => {
    const response = await genericApi.register(token, payload)

    return response.data
  })

  const register = useCallback((values) => mutation.mutate(values), [mutation])

  return { register, ...mutation }
}
